import { mediaQuery, slideToggle } from '~/js/helpers';
const widgetTitles = document.querySelectorAll('footer .widgets .widget_nav_menu .widget-title');
const widgetMenus = document.querySelectorAll('footer .widgets .widget_nav_menu .menu');
let expandState = 'false';

document.addEventListener('DOMContentLoaded', () => {
	initFooterMenus();
});

window.addEventListener('resize', () => {
	initFooterMenus();
});

function initFooterMenus() {
	if (mediaQuery('sm') || mediaQuery('md')) {
		expandState = 'false';
		widgetMenus.forEach((menu) => (menu.style.display = 'none'));

		widgetTitles.forEach((title) => {
			title.setAttribute('tabindex', '0');
			title.setAttribute('role', 'button');
			title.classList.add('cursor-pointer');
		});
	} else {
		expandState = 'true';
		widgetTitles.forEach((title) => {
			title.removeAttribute('tabindex');
			title.removeAttribute('role', 'button');
			title.classList.remove('cursor-pointer');
		});
		widgetMenus.forEach((menu) => (menu.style.display = 'block'));
	}

	widgetMenus.forEach((menu) => menu.setAttribute('aria-expanded', expandState));
}

// Toggle submenu's
widgetTitles.forEach((title) => {
	title.addEventListener('click', () => {
		if (mediaQuery('sm') || mediaQuery('md')) {
			slideToggle(title.parentNode.querySelector('.menu'));
			title.querySelector('i').classList.toggle('rotate-180');

			// Toggle aria-expanded attribute
			expandState = title.nextSibling.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
			title.nextSibling.setAttribute('aria-expanded', expandState);
		}
	});

	title.addEventListener('keypress', (key) => {
		if (key.code === 'Enter') {
			if (mediaQuery('sm') || mediaQuery('md')) {
				slideToggle(title.parentNode.querySelector('.menu'));
				title.querySelector('i').classList.toggle('rotate-180');

				// Toggle aria-expanded attribute
				expandState = title.nextSibling.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
				title.nextSibling.setAttribute('aria-expanded', expandState);
			}
		}
	});
});
